import menuHearingAid from './dashboard';
import menuKiosk from './dashboardKiosk'; 

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  //items: [menuHearingAid, menuKiosk]
  items: [menuHearingAid, menuKiosk]
};

export default menuItems;
